// extracted by mini-css-extract-plugin
module.exports = {"root":"StyledMenu_root__ZeyQ8"};